import React from "react";
import { Exercise } from "../../models/Exercise";
import { Button, createStyles, darken, Theme } from "@material-ui/core";
import { format, isPast } from "date-fns";
import styled from "styled-components";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { blue, green, grey, orange } from "@material-ui/core/colors";
import { useSelector } from "react-redux";
import { State } from "../../store";
import getId from "../../utils/getId";
import "./ExerciseBtnStyle.scss";
import ButtonNav from "../../shared/NavBar/ButtonNav";

interface IProps {
  exercise: Exercise;
  onBtnClick: (exercise: Exercise) => void;
}

const ExerciseButton = styled(Button)`
  display: inline;
  width: 33.33%;
  height: "3vw";
  border: "1px solid #fff";
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grey: {
      backgroundColor: grey[300],
      color: theme.palette.getContrastText(grey[300]),
      "&:hover": {
        backgroundColor: darken(grey[300], 0.1),
      },
      borderRadius: 0,
      cursor: "not-allowed",
    },
    free: {
      backgroundColor: green[600],
      color: theme.palette.getContrastText(green[600]),
      "&:hover": {
        backgroundColor: darken(green[600], 0.1),
      },
      borderRadius: 0,
    },
    select: {
      backgroundColor: orange[500],
      color: theme.palette.getContrastText(orange[500]),
      "&:hover": {
        backgroundColor: darken(orange[500], 0.1),
      },
      borderRadius: 0,
    },
    notAvailable: {
      backgroundColor: blue[500],
      color: theme.palette.getContrastText(blue[500]),
      "&:hover": {
        backgroundColor: darken(blue[500], 0.1),
      },
      borderRadius: 0,
      cursor: "not-allowed",
    },
  })
);

const ExerciseBtn: React.FC<IProps> = ({ exercise, onBtnClick }: IProps) => {
  const classes = useStyles();
  const selectExercise = useSelector((state: State) => state.basket.exerciseSelect);
  const isSelectExercise = selectExercise.some((item) => getId(item) === getId(exercise));
  const exerciseFree = exercise.reserved - exercise.capacity;
  const exerciseIsAvailable = isPast(new Date(exercise.startTime));
  const exerciseDisabled = () => {
    if (exerciseIsAvailable) {
      return false;
    }
    if (exerciseFree === 0) {
      return false;
    }
    if (exercise.saleVisibility === "N") {
      return false;
    }
    return true;
  };

  const exerciseBusy = () => {
    if (exerciseFree === 0) {
      return classes.grey;
    }
    if (isSelectExercise) {
      return classes.select;
    }
    if (exercise.saleVisibility === "N") {
      return classes.grey;
    }
    if (exerciseIsAvailable) {
      return classes.grey;
    }
    return classes.free;
  };

  return (
    <div
      className="ticket--block shadow--box"
      onClick={exerciseDisabled() ? () => onBtnClick(exercise) : () => {}}
      style={{ cursor: "pointer" }}
    >
      <div className="ticket--block--image" style={{ backgroundImage: `url(${exercise.imageUrl})` }}></div>

      <div className="ticket--block--title">
        <strong>{exercise.name}</strong>
        <article className="description-light">{format(exercise.startTime, "HH:mm")}</article>
      </div>

      <div className="button--container">
        {exerciseDisabled() ? (
          <ButtonNav fullWidth={true}>
            <span>Wybierz</span>
          </ButtonNav>
        ) : (
          <ButtonNav fullWidth={true} buttonStyle={"btn--danger"}>
            <span style={{ color: "#000" }}>Niedostępne</span>
          </ButtonNav>
        )}
      </div>
    </div>
  );
};

export default ExerciseBtn;
